import {getAuthClient} from "@trumpf/ux.utils";

const scope = "notificationmanagement";
const authClient = getAuthClient(scope);
const tokenRetrievalTimeout = 30000;

type AuthToken = string | null;
let sharedPendingTokenPromise: Promise<AuthToken> | null = null; // deduplicate concurrent requests by sharing promise - late joiners inherit remaining timeout!
let timeoutId: ReturnType<typeof setTimeout>;

export const getAuthToken = async () => {
	const currentToken = authClient.getAccessToken();
	if (currentToken) return currentToken;

	if (sharedPendingTokenPromise !== null) return sharedPendingTokenPromise;

	const timeout = new Promise<never>((_, reject) => {
		timeoutId = setTimeout(() => reject(new Error(`Token retrieval timed out after ${tokenRetrievalTimeout}ms`)), tokenRetrievalTimeout);
	});

	sharedPendingTokenPromise = Promise.race([timeout, authClient.getAccessTokenAsync()])
		.catch((error) => {
			throw error;
		})
		.finally(() => {
			clearTimeout(timeoutId);
			sharedPendingTokenPromise = null;
		});

	return sharedPendingTokenPromise;
};
